import ImageRowItem from "../../../components/ImageRowItem";
import { getConfig } from "../../../hooks/use-config";
import { getLabel } from "../../../hooks/use-labels";

import { getCountry } from "../../../utils/common-utils";
import { VOLUME_UNIT } from "../../../utils/constants";

export const prepareProductDetail = ({ product, materialName }) => {
  const {
    volume,
    supplier: {
      address: { countryCode },
      referenceUrlLogo,
      name,
    },
    containerType,
    containerOption: { accessory },
    description,
  } = product;

  const details = [
    {
      label: getLabel("supplierTitle"),
      value: (
        <ImageRowItem
          title={name}
          showShadow={true}
          imageRowItemClass="row-item-image"
          imageContainerClass="img-24"
          titleClass={"font-16-bold-500-lh-18"}
          imageSrc={`${referenceUrlLogo}?size=sm`}
        />
      ),
    },
    ...(!accessory
      ? [
          {
            label: getLabel("countryOfOriginLabel"),
            value: getCountry(countryCode).label,
          },
          {
            label: getLabel("containerType"),
            value: getConfig(containerType.code) || containerType.defaultTitle,
          },
          { label: getLabel("containerMaterialLabel"), value: materialName },
          {
            label: getLabel("volumeLabel"),
            value: `${volume} ${!accessory ? VOLUME_UNIT : ""}`,
          },
        ]
      : [
          {
            label: "",
            value: description,
            valueItemClass: "text-justify",
            hideLabel: true,
          },
        ]),
  ];

  return details;
};
